export default "__VITE_ASSET__RbsPFu87__"